import * as React from "react"
import {faBook, faCheckCircle, faInfoCircle} from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {InputText, Loader, SelectDate} from "../index"
import {remotePost} from "../../remotes/api"
import {Select} from "../Forms/index.tsx"
import dayjs from "dayjs";

const signal = new AbortController()
const _dial = [
    {id: "+ 1", title: "+ 1"},
    {id: "+ 257", title: "+ 257"},
    {id: "+ 237", title: "+ 237"},
    {id: "+ 242", title: "+ 242"},
    {id: "+ 235", title: "+ 235"},
    {id: "+ 33", title: "+ 33"},
    {id: "+ 241", title: "+ 241"},
]

type BookingType = {
    vehicle: {
        slug: string,
        price: string,
        currency: string,
    },
}

export default function Booking({vehicle}: BookingType) {

    const [dateInfo, setDateInfo] = React.useState<any>({})
    const [loading, isLoading] = React.useState<boolean>(false)
    const [name, setName] = React.useState<string>('')
    const [email, setEmail] = React.useState<string>('')
    const [phone, setPhone] = React.useState<string>('')
    const [dial, setDial] = React.useState<string>('')
    const [error, setError] = React.useState<string>('')
    const [booked, isBooked] = React.useState<boolean>(false)

    const dateSelected = ({startDate, endDate, duration}: any) => {
        setDateInfo({start_date: startDate, end_date: endDate, duration})
    }


    const handleBooking = async () => {

        try {
            // start loading process
            isLoading(true)

            // Reset the error
            setError('')

            // Remote api
            const response = await remotePost(`vehicles/${vehicle.slug}/booking`, {...dateInfo, name, email, phone, dial}, signal) as any

            if (response && response.response) {
                isBooked(true)
            }

        } catch (e : any) {

            const statusUnprocessable = e.response.status === 422
            if (statusUnprocessable) {

                const errors = e.response.data.errors as [];
                const firstErrorMessage = Object.values(errors)[0][0] as string;

                setError(firstErrorMessage)
            }
        } finally {
            isLoading(false)
        }
    }


    return (
        <>
            <SelectDate
                handleDateChanged={dateSelected}
                startAt={ dateInfo.start_date ? dayjs(dateInfo.start_date).toDate() : undefined }
                endAt={ dateInfo.end_date ? dayjs(dateInfo.end_date).toDate() : undefined }
                diffInDay={ dateInfo.duration ? dateInfo.duration : undefined }
            />

            <>
                <InputText
                    label='Nom complet'
                    text={name}
                    uid='full_name'
                    placeholder='Manu Johane'
                    onChanged={(text: string) => setName(text) }
                />

                <div className='row'>
                    <div className='col-4'>
                        <Select
                            label='Indicatif'
                            text={dial}
                            uid='dial'
                            onChanged={(text: string) => setDial(text) }
                            data={_dial}
                        />
                    </div>
                    <div className='col-8'>
                        <InputText
                            label='Téléphone'
                            placeholder='9 23 78 21 00'
                            type='tel'
                            text={phone}
                            uid='phone'
                            onChanged={(text: string) => setPhone(text) }
                        />
                    </div>
                </div>
                <InputText
                    label='Adresse email'
                    placeholder='letanou@live.com'
                    text={email}
                    uid='email'
                    onChanged={(text: string) => setEmail(text) }
                />
            </>

            {error.length > 0 && (
                <p className='alert alert-danger text-center small py-2'>
                    <FontAwesomeIcon className='px-2' icon={faInfoCircle} />
                    {error}
                </p>
            )}

            {loading && <Loader text="Réservation en cours ..." />}

            {booked && <BookedMessage />}

            {!loading &&  !booked && (
                <button className='btn btn-success w-100 my-2 font-weight-bold small' onClick={handleBooking}>
                    <FontAwesomeIcon className='px-2' icon={faBook} />
                    <span className='text-uppercase'>Réservez</span> {dateInfo && dateInfo.duration && (
                        <span className='small'>
                            pour {(parseInt(dateInfo.duration) * parseFloat(vehicle.price)).toFixed(2)} {vehicle.currency}
                        </span>
                    )}
                </button>
            )}
        </>
    )
}

const BookedMessage = () => {
    return (
        <>
            <div className='text-center my-3 alert alert-success p-2'>
                <h5>Votre réservation a été créée !</h5>
                <FontAwesomeIcon className='mr-2 fa-3x text-success' icon={faCheckCircle} /><br/>
                Un message de confirmation vous a également été envoyé par email !
            </div>
        </>
    )
}
